import axios from "axios";

const url = process.env.REACT_APP_API_URL_USER
const contentType = 'application/json'

export default class UserService {

    login(username, password) {
        return axios.post(url + '/auth/login', {
            "username": username,
            "password": password
        }, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    updatePass(jsondata) {
        return axios.post(url + '/auth/update-password', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listTraderAlamat(kodeTrader, alamat, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        if (alamat !== null) {
            param += '&alamat=' + alamat
        }
        return axios.get(url + '/trader-alamat?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTraderAlamatById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/trader-alamat/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTraderAlamat(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/trader-alamat', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTraderAlamat(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/trader-alamat', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteTraderAlamatById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/trader-alamat/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listIkanTrader(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ikan-trader?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getIkanTraderById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ikan-trader-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    addIkanTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ikan-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editIkanTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ikan-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteIkanTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ikan-trader', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    listPartner(nama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nama != null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/partner?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPartnerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/partner/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPartner(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/partner', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPartner(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/partner', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePartnerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/partner/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPegawai(nama, kdUnit, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nama != null) {
            param += '&nama=' + nama
        }
        if (kdUnit != null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/pegawai?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPegawaiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/pegawai/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPegawai(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pegawai', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPegawai(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pegawai', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePegawaiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pegawai/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUser(username, nama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (username != null) {
            param += '&username=' + username
        }
        if (nama != null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/user?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getUserById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/user/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addUser(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/user', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editUser(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/user', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteUserById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/user/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listRole(roleUser, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (roleUser != null) {
            param += '&roleUser=' + roleUser
        }
        return axios.get(url + '/role?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getRoleById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return token !== null && axios.get(url + '/role/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addRole(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/role', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editRole(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/role', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteRoleById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/role/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listTrader(npwp, nama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (npwp != null) {
            param += '&npwp=' + npwp
        }
        if (nama != null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/trader?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTraderById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return id !== undefined && axios.get(url + '/trader/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteTraderById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/trader/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUpi(upiNama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (upiNama != null) {
            param += '&upiNama=' + upiNama
        }
        return axios.get(url + '/upi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUpiTrader(kodeTrader, upiNama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (upiNama != null) {
            param += '&nama=' + upiNama
        }
        return axios.get(url + '/upi-trader?page=' + page + '&size=' + size + '&kodeTrader=' + kodeTrader + param + '&sort=upiRegNo,asc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getUpiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return id !== undefined && axios.get(url + '/upi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addUpi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/upi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editUpi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/upi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteUpiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/upi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUpiRegister(upiRegNo, kodeTrader, upiId, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (upiRegNo != null) {
            param += '&upiRegNo=' + upiRegNo
        }
        if (kodeTrader != null) {
            param += '&kodeTrader=' + kodeTrader
        }
        if (upiId != null) {
            param += '&upiId=' + upiId
        }
        return axios.get(url + '/upi-register?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUpiReg(upiRegNo,upiId, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (upiRegNo != null) {
            param += '&upiRegNo=' + upiRegNo
        }
        if (upiId != null) {
            param += '&upiId=' + upiId
        }
        return axios.get(url + '/upi-reg?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getUpiRegisterById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/upi-register/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addUpiRegister(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/upi-register', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editUpiRegister(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/upi-register', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteUpiRegisterById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/upi-register/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUpt(nmUnit, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmUnit != null) {
            param += '&nmUnit=' + nmUnit
        }
        return axios.get(url + '/upt?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getUptById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return id !== undefined && axios.get(url + '/upt/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addUpt(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/upt', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editUpt(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/upt', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteUptById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/upt/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPartnerTrader(kodeTrader, idPartner, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeTrader != null) {
            param += '&kodeTrader=' + kodeTrader
        }
        if (idPartner != null) {
            param += '&idPartner=' + idPartner
        }
        return axios.get(url + '/partner-trader?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPartnerByTrader(kodeTrader, nama, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeTrader != null) {
            param += '&kodeTrader=' + kodeTrader
        }
        if (nama !== null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/partner-by-trader?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPartnerTraderById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/partner-trader-by-id', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    tambahPartnerTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/partner-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPartnerTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/partner-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePartnerTraderById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/partner-trader', {
            headers: {
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    addUpiTrader(jsonData){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/add-upi-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })        
    }

    addPartnerTrader(jsonData){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/add-partner-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }
}